module.exports = __webpack_public_path__ + "img/bianpao_des_1.f3b2d2bc.jpg";